import { useQuery } from '@tanstack/react-query';
import { queryKeys, unwrap, type components } from '@geefamily/api';
import { api } from '@/app/api';

export type Promotion = components['schemas']['PromotionResponse'];

const keys = queryKeys.module('promotions').entity('list');

/**
 * Live promotions.
 *
 * Shorter stale time than the site catalogue: promotions carry optional start
 * and end dates, so this list goes out of date on its own rather than only when
 * an editor touches it.
 */
export function usePromotions(featuredOnly = false) {
  return useQuery({
    queryKey: keys.list({ featured: featuredOnly }),
    queryFn: () =>
      unwrap<Promotion[]>(
        api.GET('/api/v1/promotions', { params: { query: { featured: featuredOnly } } }),
      ),
    staleTime: 2 * 60_000,
  });
}

/** Turkish labels for the bonus kinds the API returns. */
export const promotionKindLabels: Record<string, string> = {
  depositbonus: 'Yatırım bonusu',
  cashback: 'Kayıp iadesi',
  freespins: 'Bedava dönüş',
  rakeback: 'Rakeback',
  nodeposit: 'Yatırımsız',
  other: 'Kampanya',
};
